import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";

const CustomerAdmins = ({ admins }) => {
    if (!admins.length) {
        return null;
    }

    return (
        <div className={ styles.customerAdmins }>
            <div className={ styles.header }>
                Customer admins
            </div>
            <div className={ styles.list }>
                { admins.map((admin, index) => <CustomerAdmin key={ index } admin={ admin } />) }
            </div>
        </div>
    );
};

const CustomerAdmin = ({ admin }) => {
    const {
        firstName,
        lastName,
        email
    } = admin;

    const name = `${ firstName || "" } ${ lastName || "" } `;

    return (
        <div className={ styles.admin }>
            { name }
            <span className={ styles.email }>
                { email }
            </span>
        </div>
    );
};

const ADMIN_PROP_TYPE_SHAPE = PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string.isRequired
});

CustomerAdmins.propTypes = {
    admins: PropTypes.arrayOf(ADMIN_PROP_TYPE_SHAPE).isRequired
};

CustomerAdmin.propTypes = {
    admin: ADMIN_PROP_TYPE_SHAPE.isRequired
};

export default CustomerAdmins;
